












































import Vue from 'vue';
// import HelloWorld from './components/HelloWorld.vue';
import { App as DlApp } from './scripts/lib/desertland.app';

export default Vue.extend({
  name: 'app',
  components: {
    // HelloWorld,
  },
  mounted () {
    // `this` points to the vm instance
    // console.log('App mounted -> start!');
    DlApp.start(); 
  }
});
